import { padStart } from 'lodash'

/**
 * Convert milliseconds to minutes and seconds
 * @param  {Number} milliseconds
 * @return {String}
 */
export function millisecondsToMinutesAndSeconds (milliseconds) {
  const minutes = Math.floor(milliseconds / 60)
  const seconds = padStart(milliseconds % 60, 2, 0)

  return `${minutes}:${seconds}`
}

/**
 * Build a URL query string
 * @param  {Object} params
 * @return {String}
 */
export function buildQueryString (params) {
  let queryString = ''
  for (var prop in params) queryString += `&${prop}=${encodeURIComponent(params[prop])}`
  return queryString
}



// WEBPACK FOOTER //
// ./src/helpers/index.js